import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageStyleBaseComponent } from 'app/shared/components/base/page-style-base/page-style-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Url } from 'app/shared/constants/url';
import { PaymentValidation } from 'app/shared/models/payment-validation.model';
import { Payment } from 'app/shared/models/payment.model';
import { PageStyleService } from 'app/shared/services/page-style.service';
import { PaymentService } from 'app/shared/services/payment.service';

@Component({
  selector: 'app-payment-redirected',
  templateUrl: './payment-redirected.component.html',
  styleUrls: ['./payment-redirected.component.scss']
})
export class PaymentRedirectedComponent extends PageStyleBaseComponent implements OnInit {

  authorizationCode: string;
  redirectUrl: string;
  payment: Payment;
  interval: any;
  numberOfAttempts = 0;

  get hasStatusCreated(): boolean {
    if (this.hasStatusInProgress) {
      return false;
    }
    if (this.hasStatusCompleted) {
      return false;
    }
    if (this.hasStatusCanceled) {
      return false;
    }
    if (this.hasStatusFailed) {
      return false;
    }
    return true;
  }

  get hasStatusInProgress(): boolean {
    return this.payment.IsInProgress;
  }

  get hasStatusCompleted(): boolean {
    return this.payment.IsCompleted;
  }

  get hasStatusCanceled(): boolean {
    return this.payment.IsCanceled;
  }

  get hasStatusFailed(): boolean {
    return this.payment.IsFailed;
  }

  constructor(protected paymentService: PaymentService, protected pageStyleService: PageStyleService, private route: ActivatedRoute, private router: Router) {
    super(pageStyleService);
  }

  ngOnInit(): void {
    this.initializeObject();
    this.route
      .queryParams
      .subscribe(params => {
        this.authorizationCode = params.authorizationCode;

        super.initialize(this.authorizationCode, () => this.initializeStyles());
        this.paymentService.getObject<PaymentValidation>(
          Url.PaymentValidate.replace('{authorizationCode}', this.authorizationCode),
          null,
          (paymentValidation) => {
            this.handlePaymentValidation(paymentValidation);
          },
          true,
          false,
          true);
      });
  }

  initializeObject(): void {
    if (this.payment == null) {
      this.payment = new Payment();
    }
  }

  handlePaymentValidation(paymentValidation: PaymentValidation): void {
    if (!paymentValidation.IsValid) {
      this.router.navigate(['/payments/payment-request-url-invalid'], {queryParams: {authorizationCode: this.authorizationCode}});
    } else {
      this.paymentService.getObject<Payment>(`${Url.Payment}/${this.authorizationCode}`, null, (payment) => {
        this.payment = payment;
      },
        true,
        false,
        true);
      this.interval = setInterval(() => {
        this.handleUpdate();
      }, Constants.UpdateInterval);
    }
  }

  handleUpdate(): void {
    this.paymentService.getObject<Payment>(Url.PaymentUpdate.replace('{authorizationCode}', this.authorizationCode), null, (payment) => {
      this.payment = payment;
      if (this.hasStatusCompleted || this.hasStatusCanceled || this.hasStatusFailed || this.numberOfAttempts >= 5) {
        clearInterval(this.interval);
      } else {
        this.numberOfAttempts++;
      }
    },
      true,
      false,
      true);
  }
}
